// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExploreFaq_wrapper__CpCID","item":"ExploreFaq_item__M1EFE"};